// import { ref } from 'vue'
import blogs from './data/blogs.json'

const getBlog = (id) => {
    const blogSnapshot = blogs.find(bs => bs.id == id);
    return { blogSnapshot }
}

export default getBlog